<div *ngIf="alert">
  <ngb-alert #selfClosingAlert type="{{alert.type.color}}" 
    class="alert alert-primary alert-border-left alert-dismissible fade show custom-alert" (closed)="alert=null">
    <i class="{{alert.type.icon}} me-3 align-middle fs-16"></i>
    <!-- <strong>{{defaultData[3].color}}</strong> - -->
     {{ alert.message }}
  </ngb-alert>
</div>